"use strict";

exports.__esModule = true;
var _DeviceLagController = require("./DeviceLagController");
Object.keys(_DeviceLagController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceLagController[key]) return;
  exports[key] = _DeviceLagController[key];
});